import { QUERY_KEYS } from "@/common/query-keys";
import { useSettings } from "@/context/settings-context";
import { fetchLocationById } from "@/lib/snipeit/locations";
import type { SnipeItLocation } from "@/lib/snipeit/types";
import { useQuery } from "@tanstack/react-query";

/**
 * Fetches the full location object for the ID stored in settings.
 * The name is always fresh from the API, so renames in Snipe-IT propagate automatically.
 */
export function useLocationDetail(): { location: SnipeItLocation | null; isLoading: boolean } {
  const { locationId } = useSettings();

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.locationDetail, locationId],
    queryFn: () => fetchLocationById(locationId!),
    enabled: locationId !== null,
    staleTime: 5 * 60 * 1000, // re-fetch at most every 5 min
  });

  return { location: data ?? null, isLoading: isLoading && locationId !== null };
}
